import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from '../../../common/services/utility-service';
import { constObj } from '../../../common/Constants/constants';
import { ConfirmDialogComponent } from '../../../common/shared-components/confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-help-annotations',
  templateUrl: './help-annotations.component.html'
})
export class HelpAnnotationsComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private router: Router,
    public dialog: MatDialog,
    private utilityService: UtilityService) {
    this.isArchiveApplication();
  }
  archiveVersion: string = "";
  isArchive: boolean = false;
  help_annotationsHeader;
  help_annotationsDescription;
  help_annotationsToCreateHeader;
  help_annotationsToCreateDesc;
  help_annotationdisplayandhide;
  help_annotationsMyDesc;
  help_annotationdisplayandhide_subhead1;
  help_annotationdisplayandhide_subhead2;
  help_annotationdisplayandhide_subtext1;
  help_annotationdisplayandhide_subtext2;
  help_viewingallAnnotation;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.gethelpannotationslabels();
  }
  ngOnDestroy() {
    this.commonDataService.loadCurrentLeftNav.next(null);
  }
  gethelpannotationslabels() {
    this.graphQlService.getHelpAnnotationsComponentLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.help_annotationsHeader = labels.filter(x => x.key == "help_annotationsHeader").map(y => y.value);
        this.help_annotationsDescription = labels.filter(x => x.key == "help_annotationsDescription").map(y => y.value);
        this.help_annotationsToCreateHeader = labels.filter(x => x.key == "help_annotationsToCreateHeader").map(y => y.value);
        this.help_annotationsToCreateDesc = labels.filter(x => x.key == "help_annotationsToCreateDesc").map(y => y.value);
        this.help_annotationdisplayandhide = labels.filter(x => x.key == "help_annotationdisplayandhide").map(y => y.value);
        this.help_annotationdisplayandhide_subhead1 = labels.filter(x => x.key == "help_annotationdisplayandhide_subhead1").map(y => y.value);
        this.help_annotationdisplayandhide_subhead2 = labels.filter(x => x.key == "help_annotationdisplayandhide_subhead2").map(y => y.value);
        this.help_annotationdisplayandhide_subtext1 = labels.filter(x => x.key == "help_annotationdisplayandhide_subtext1").map(y => y.value);
        this.help_annotationdisplayandhide_subtext2 = labels.filter(x => x.key == "help_annotationdisplayandhide_subtext2").map(y => y.value);
        this.help_viewingallAnnotation = labels.filter(x => x.key == "help_viewingallAnnotation").map(y => y.value);
        this.help_annotationsMyDesc = labels.filter(x => x.key == "help_annotationsMyDesc").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }
  isArchiveApplication() {
    this.archiveVersion = localStorage.getItem("ArchiveVersion");
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("ArchiveVersion"));
      this.isArchive = Boolean(this.archiveVersion);
    }
    else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId") && (this.archiveVersion != null && this.archiveVersion != undefined)) {
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
      this.isArchive = Boolean(this.archiveVersion);
    }
    else { this.isArchive = false; }
  }
  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home")
      }
    });
  }
}
